import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"

const IntroBackground = ({ children }) => {
  const { desktop, medium, small } = useStaticQuery(
    graphql`
      query {
        desktop: file(relativePath: { eq: "projector.jpg" }) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 4160) {
              # ...GatsbyImageSharpFluid_withWebp
              ...GatsbyImageSharpFluid
            }
          }
        }

        medium: file(relativePath: { eq: "abstract.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 1400, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        small: file(relativePath: { eq: "abstract.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 490, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `
  )
  const backgroundImgStack = [
    small.childImageSharp.fluid,
    {
      ...medium.childImageSharp.fluid,
      media: `(min-width: 491px)`,
    },
    {
      ...desktop.childImageSharp.fluid,
      media: `(min-width: 1401px)`,
    },
  ]
  return (
    <section>
      <BackgroundImage
        Tag="section"
        fluid={backgroundImgStack}
        backgroundColor={`#040e18`}
        id="fullscreenbg"
        opacity="0.8"
        role="img"
        aria-label="Projector fullscreen background"
        preserveStackingContext={true}
      >
        {children}
      </BackgroundImage>
    </section>
  )
}
export default IntroBackground
